var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.selection &&
    (_vm.currentBetSlipState < 1 ||
      ((_vm.tab == "REGULAR" &&
        _vm.betTypeStakes[_vm.selection.idfoselection]) ||
        _vm.tab == "RR-" ||
        _vm.tab == "TEASER-"))
      ? _c(
          "div",
          {
            staticClass: "bsSelection",
            class: [
              _vm.tab,
              "id-" + _vm.selectionId,
              _vm.isFor,
              "sport-" + _vm.sport,
              {
                multiSingles: _vm.multiSingles,
                mixedTeasers: _vm.mixedTeasers,
                inRefferalStakeChanged:
                  _vm.inRefferalStakeChanged && _vm.currentBetSlipState == 6,
                priceUp:
                  (_vm.priceUp || (_vm.tab == "TEASER" && _vm.hcpUp)) &&
                  !(_vm.isclosed || _vm.issuspended || _vm.isNr),
                priceDown:
                  (_vm.priceDown || (_vm.tab == "TEASER" && _vm.hcpDown)) &&
                  !(_vm.isclosed || _vm.issuspended || _vm.isNr),
                isClosed: _vm.isclosed,
                isSuspended: _vm.issuspended,
                isNR: _vm.isNr,
                hliteNew:
                  _vm.hliteNew &&
                  !(_vm.isclosed || _vm.issuspended || _vm.isNr),
                hcpUp: _vm.hcpUp,
                hcpDown: _vm.hcpDown,
                optedOut:
                  (_vm.tab == "RR" && !_vm.selectedObj[_vm.id]) ||
                  (_vm.tab == "TEASER" && !_vm.selectedObj[_vm.id]),
                edit: _vm.currentBetSlipState == 0,
                review: _vm.currentBetSlipState == 1,
                changed:
                  !_vm.isclosed &&
                  !_vm.issuspended &&
                  !_vm.isNr &&
                  (_vm.priceUp || _vm.priceDown || _vm.hcpUp || _vm.hcpDown)
              },
              "state-" + _vm.currentBetSlipState,
              _vm.interRelatedClass
            ]
          },
          [
            _c(
              "h2",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tab == "REGULAR" && _vm.currentBetSlipState >= 1,
                    expression: "tab=='REGULAR' && currentBetSlipState>=1"
                  }
                ],
                staticClass: "header-SING"
              },
              [
                _vm._v(
                  "\n    " + _vm._s(_vm.$t("BetSlip.tab.title.SINGLE")) + "\n  "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "selection" },
              [
                !_vm.isclosed &&
                !_vm.issuspended &&
                (_vm.priceUp || _vm.priceDown || _vm.hcpUp || _vm.hcpDown)
                  ? _c(
                      "div",
                      { staticClass: "header-changed msg info" },
                      [
                        _c("icon", {
                          attrs: { name: "icon-information", colorName: "blue" }
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm.priceUp
                            ? _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("BetSlip.selection.changed.priceUp")
                                  )
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.priceDown
                            ? _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "BetSlip.selection.changed.priceDown"
                                    )
                                  )
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hcpUp
                            ? _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("BetSlip.selection.changed.hcpUp")
                                  )
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hcpDown
                            ? _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("BetSlip.selection.changed.hcpDown")
                                  )
                                )
                              ])
                            : _vm._e()
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.tab == "REGULAR"
                  ? _c("div", { staticClass: "event-name" }, [
                      _c(
                        "div",
                        { staticClass: "bs_left" },
                        [
                          _vm.selection.idfosporttype
                            ? _c("icon", {
                                attrs: {
                                  name:
                                    "icon-" +
                                    _vm.selection.idfosporttype
                                      .split(" ")
                                      .join("")
                                      .toLowerCase()
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { staticClass: "eventname" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.formatSelectionName(_vm.selection))
                              )
                            ]),
                            _vm._v(" "),
                            _vm.selection && _vm.selection.currenthandicap
                              ? _c("span", { staticClass: "currenthandicap" }, [
                                  _vm._v(
                                    _vm._s(_vm.formatHandicap(_vm.selection))
                                  )
                                ])
                              : _vm._e()
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "bs_right" }, [
                        false &&
                        _vm.tab == "REGULAR" &&
                        !_vm.isLive &&
                        _vm.market.tsstart &&
                        _vm.currentBetSlipState < 1
                          ? _c("span", { staticClass: "selection-ts" }, [
                              _c("span", { staticClass: "time" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("moment")(
                                      _vm.market.tsstart,
                                      _vm.dateFormats.longTime
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "date" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("moment")(
                                      _vm.market.tsstart,
                                      _vm.dateFormats.shortDate
                                    )
                                  )
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "market-name" }, [
                          _vm._v(_vm._s(_vm.market.name))
                        ]),
                        _vm._v(" "),
                        _vm.tab == "REGULAR" && _vm.currentBetSlipState < 1
                          ? _c(
                              "button",
                              {
                                staticClass: "btnX",
                                on: {
                                  click: function($event) {
                                    return _vm.removeSelection(_vm.selection)
                                  }
                                }
                              },
                              [
                                _c("icon", {
                                  attrs: {
                                    name: "icon-trash",
                                    colorName: "red"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btnToggleVisibility",
                            on: { click: _vm.toggleBetVisibility }
                          },
                          [
                            _c("icon", {
                              attrs: {
                                name: _vm.betVisibility
                                  ? "icon-chevron-down"
                                  : "icon-chevron-top",
                                colorName: "red"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "vue-slide-up-down",
                  { attrs: { active: _vm.betVisibility, duration: 500 } },
                  [
                    _c("div", { staticClass: "columns" }, [
                      _c(
                        "div",
                        { staticClass: "column column-left" },
                        [
                          _vm.isLive && _vm.tab != "RR"
                            ? _c("span", { staticClass: "isLive" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("BetSlip.selection.isLive"))
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.tab != "REGULAR" && _vm.showCheckbox === true
                            ? _c("v-checkbox", {
                                attrs: {
                                  type: "checkbox",
                                  id: _vm.id.toString(),
                                  value: _vm.selectedObj[_vm.id],
                                  disabled: _vm.currentBetSlipState >= 1
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.updateSelected(_vm.sport)
                                  }
                                },
                                model: {
                                  value: _vm.selectedObj[_vm.id],
                                  callback: function($$v) {
                                    _vm.$set(_vm.selectedObj, _vm.id, $$v)
                                  },
                                  expression: "selectedObj[id]"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          ((_vm.tab == "TEASER" && _vm.mixedTeasers) ||
                            _vm.tab == "RR") &&
                          _vm.showCheckbox === false
                            ? _c(
                                "span",
                                { staticClass: "icon" },
                                [
                                  _c("icon", {
                                    attrs: {
                                      name:
                                        "icon-" +
                                        _vm.market.idfosporttype
                                          .split(" ")
                                          .join("")
                                          .toLowerCase()
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "column column-right",
                          on: {
                            click: function($event) {
                              return _vm.toggleOptedIn(_vm.sport)
                            }
                          }
                        },
                        [
                          _c("label", { attrs: { for: _vm.id } }, [
                            _c("div", { staticClass: "selection-data" }, [
                              _vm.tab != "REGULAR"
                                ? _c(
                                    "div",
                                    { staticClass: "event-name-inner" },
                                    [
                                      _c("span", { staticClass: "name" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "eventname",
                                            class: {
                                              "teaser-icon-shifted":
                                                _vm.mixedTeasers &&
                                                _vm.tab == "TEASER" &&
                                                _vm.currentBetSlipState > 0
                                            }
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatSelectionName(
                                                    _vm.selection
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _vm.selection &&
                                            _vm.selection.currenthandicap
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "currenthandicap"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatHandicap(
                                                          _vm.selection
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.tab !== "TEASER" &&
                                      _vm.tab !== "REGULAR"
                                        ? _c(
                                            "div",
                                            { staticClass: "selection-price" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "price" },
                                                [
                                                  !_vm.isclosed &&
                                                  !_vm.issuspended &&
                                                  !_vm.isNr
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.formatSelectionPrice(
                                                              _vm.selection
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.isclosed ||
                                                  _vm.issuspended ||
                                                  _vm.isNr
                                                    ? _c("span", [
                                                        _vm.isclosed
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "price_title"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "BetSlip.selection.isClosed"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.issuspended
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "price_title"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "BetSlip.selection.isSuspended"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.isNr
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "price_title"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "BetSlip.selection.isNr"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ])
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.tab == "TEASER"
                                        ? _c(
                                            "div",
                                            { staticClass: "selection-price" },
                                            [
                                              !_vm.isclosed &&
                                              !_vm.issuspended &&
                                              !_vm.isNr
                                                ? _c(
                                                    "span",
                                                    { staticClass: "price" },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.selectedTeaser[
                                                              _vm.sport
                                                            ] &&
                                                              _vm.formatHandicap(
                                                                _vm.teasers[
                                                                  _vm
                                                                    .selectedTeaser[
                                                                    _vm.sport
                                                                  ]
                                                                ][
                                                                  _vm.selection
                                                                    .idfoselection
                                                                ]
                                                              )
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.isclosed ||
                                              _vm.issuspended ||
                                              _vm.isNr
                                                ? _c("span", [
                                                    _vm.isclosed
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "price_title"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "BetSlip.selection.isClosed"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.issuspended
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "price_title"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "BetSlip.selection.isSuspended"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.isNr
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "price_title"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "BetSlip.selection.isNr"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ])
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "selection-name" }, [
                                _c("span", { staticClass: "name" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.wbr(_vm.market.eventname, 0))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.wbr(_vm.market.eventname, 1))
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.isLive && _vm.tab != "REGULAR"
                                  ? _c("span", { staticClass: "isLive" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("BetSlip.selection.isLive")
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _vm.tab != "REGULAR"
                                ? _c("div", { staticClass: "market-name" }, [
                                    _vm._v(_vm._s(_vm.market.name))
                                  ])
                                : _vm._e()
                            ])
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.tab == "REGULAR"
                      ? _c(
                          "div",
                          { staticClass: "stake_price" },
                          [
                            !_vm.isclosed && !_vm.issuspended && !_vm.isNr
                              ? _c("span", { staticClass: "price" }, [
                                  _c("span", { staticClass: "price_title" }, [
                                    _vm._v(_vm._s(_vm.$t("BetSlip.oddsprice")))
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatSelectionPrice(_vm.selection)
                                      )
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isclosed || _vm.issuspended || _vm.isNr
                              ? _c("span", { staticClass: "price" }, [
                                  _vm.isclosed
                                    ? _c(
                                        "span",
                                        { staticClass: "price_title" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "BetSlip.selection.isClosed"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.issuspended
                                    ? _c(
                                        "span",
                                        { staticClass: "price_title" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "BetSlip.selection.isSuspended"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isNr
                                    ? _c(
                                        "span",
                                        { staticClass: "price_title" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("BetSlip.selection.isNr")
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("stake-and-return", {
                              attrs: {
                                id: _vm.selection.idfoselection,
                                perType: "PerSelection",
                                inRefferalStakeChanged:
                                  _vm.inRefferalStakeChanged &&
                                  _vm.currentBetSlipState == 6,
                                stakeChange: _vm.stakeChange
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f572432e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f572432e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslip/betslipSelection.vue
// module id = null
// module chunks = 